import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class MainVideoPreview {
    private $container: JQuery;
    private $wrapper: JQuery;
    private $videoWrapper: JQuery;
    private $playBtn:JQuery;
    private isInitAnimation = false;
    private timeLine: gsap.core.Timeline | null = null;

    private selectors = {
        wrapper: '.js-video-preview-wrapper',
        videoWrapper: '.js-video-preview-video-wrapper',
        playBtn: '.js-video-preview-play',
    };

    constructor($container: JQuery) {
        this.$container = $container;
        this.$wrapper = this.$container.find(this.selectors.wrapper);
        this.$videoWrapper = this.$container.find(this.selectors.videoWrapper);
        this.$playBtn = this.$container.find(this.selectors.playBtn);

        this.updateAnimation();
    }

    private initAnimation(): void
    {
        if (this.isInitAnimation) {
            return;
        }

        this.timeLine = gsap.timeline({
            scrollTrigger: {
                trigger: this.$container.get(0),
                start: 'bottom bottom',
                end: () => `+=${(this.$container.get(0).clientHeight / 3) - 100}`,
                pin: true,
                scrub: 1,
                invalidateOnRefresh: true,
            }
        })
            .fromTo(this.$playBtn.get(0), {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            })
            .fromTo(this.$videoWrapper.get(0), {
                scale: 0.9,
            }, {
                scale: 1,
            }, 0)
            .fromTo(this.$wrapper.get(0), {
                yPercent: 16,
            }, {
                yPercent: 0,
            }, 0);

        this.isInitAnimation = true;
    }

    private updateAnimation(): void
    {
        this.destroyAnimation();
        if (window.matchMedia(`(min-width: 1024px`).matches) {
            this.initAnimation();
        }
    }

    private destroyAnimation(): void
    {
        if (!this.isInitAnimation) {
            return;
        }

        gsap.set([this.$container.get(0), this.$wrapper.get(0), this.$videoWrapper.get(0), this.$playBtn.get(0)], { clearProps: true });
        this.timeLine = null;
        this.isInitAnimation = false;
    }

}
